import { takeEvery } from 'redux-saga/effects';
import { DETECTION_MODULE } from '../../../configs/moduleNames';
import { LOAD_LIST } from '../actions';

import loadDetectionList from './loadDetectionList';

export default function* watchDashboard() {
  yield takeEvery(DETECTION_MODULE + LOAD_LIST, loadDetectionList);
}
